import React, { useState } from "react";
import InputField from "components/fields/InputField";
import { ApiLogin } from "../../services/ApiLogin";
import { Link, useNavigate } from "react-router-dom";
import ForgetPassword from "./ForgetPassword"
import UserCreation from "views/admin/users/components/UserCreation";

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [forgetPassword, setForgetPassword] = useState(false);
  const [createCustomer, setCreateCustomer] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await ApiLogin(email, password);
      localStorage.setItem("token", data.token);
      localStorage.setItem("username", data.username);
      localStorage.setItem("role", data.role);
      localStorage.setItem("id", data.id);
      localStorage.setItem("email", data.email);
      navigate(
        data.role === "customer" ? "/" : data.role === "agent" ? "/admin/tickets" : "/admin/dashboard"
      );
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (

    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      {!forgetPassword && !createCustomer && (
        <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
          <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
            Sign In
          </h4>
          <p className="mb-3 ml-1 text-base text-gray-600">
            Enter your email and password to sign in!
          </p>

          {/* Email */}
          <InputField
            variant="auth"
            extra="mb-3"
            label="Email*"
            placeholder="user@mail.com"
            id="email"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {/* Password */}
          <InputField
            variant="auth"
            extra="mb-3"
            label="Password*"
            placeholder="Enter Your Password"
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <div className="mb-2 flex items-center justify-between px-2">
            <div className="flex items-center">
              <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
                Not registered yet?
              </span>
              <Link
                onClick={() => setCreateCustomer(true)}
                className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
              >
                Create Account
              </Link>
            </div>
            <Link
              className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white cursor-pointer"
              onClick={() => setForgetPassword(true)}
            >
              Forgot Password?
            </Link>
          </div>

          {error && <div className="mb-3 text-sm text-red-600">{error}</div>}
          <button onClick={handleLogin}
            disabled={loading}
            className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </div>
      )}
      {/* forgetPassword section */}

      {forgetPassword && (
        <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
          <ForgetPassword setForgetPassword={setForgetPassword} />
        </div>
      )}

      {createCustomer && (
        <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
          <UserCreation setCreateCustomer={setCreateCustomer} />
        </div>
      )}
    </div>
  );
}
